import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

const Loading = (props) => {
  return (
		<LinearProgress />
  );
};

export default Loading;

